import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ModalEl } from "common/components/modal";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  const {
    t
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx(ModalEl, { sel: ".upsell-modal", attrs: {
    open: this.state.open,
    closeable: this.attr("closeable"),
    "hide-close-button": true
  }, on: {
    change: this.helpers.handleModalChange
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-content" }, this.state.backgroundImage ? /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-background" }, /* @__PURE__ */ jsx("img", { sel: ".upsell-modal-background-image", attrs: {
    src: this.state.backgroundImage
  } })) : null, /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-body" }, /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-header" }, this.attr("header")), /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-description" }, /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-description-copy" }, this.attr("description").concat(" "), this.attr("learn-more-link-url") ? /* @__PURE__ */ jsx("a", { attrs: {
    href: this.attr("learn-more-link-url"),
    target: "_blank"
  } }, "Learn More") : null)), this.attr("bold-text") ? /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-bold-text" }, this.attr("bold-text")) : null, /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-footer" }, /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-footer-left" }, /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-callouts" }, this.helpers.getCalloutStrings().map((string) => /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-footer-callout-container" }, /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-footer-callout-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "circle-checkmark"
  } })), /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-footer-callout-text" }, string)))), this.attr("learn-more-button-url") ? /* @__PURE__ */ jsx(ButtonEl, { sel: ".upsell-modal-learn-more-btn", attrs: {
    theme: ButtonTheme.Tertiary,
    role: "button",
    href: this.attr("learn-more-button-url"),
    target: "_blank"
  } }, t("common.learn-more")) : null), /* @__PURE__ */ jsx("div", { sel: ".upsell-modal-footer-right" }, this.attr("closeable") ? /* @__PURE__ */ jsx(ButtonEl, { sel: ".upsell-modal-cancel-btn", attrs: {
    theme: ButtonTheme.Tertiary,
    role: "button"
  }, on: {
    click: this.helpers.handleClickCancel
  } }, t("common.cancel")) : null, /* @__PURE__ */ jsx(ButtonEl, { sel: ".upsell-modal-upgrade-btn", attrs: {
    theme: ButtonTheme.Primary,
    role: "button",
    icon: "share",
    href: this.attr("upgrade-url"),
    target: "_blank"
  }, on: {
    click: this.helpers.handleClickUpgrade
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, this.attr("upgrade-text") || t("components.upsell-modal-cta")))))));
}
